import paper from 'paper';

export class Collision extends paper.CompoundPath {
    public neuralaType = 'Collision';
    public closed = true;
    public fullySelected = false;
    public locked = true;
    public strokeWidth = 3;
    public strokeColor = new paper.Color('rgba(0, 0, 255, 1)');
    public fillColor = new paper.Color('rgba(0, 0, 255, 0.4)');
    public strokeScaling = false;

    constructor(params: any) {
        super(params);
    }
}



// WEBPACK FOOTER //
// ./src/components/workspace/objects/collision.ts